import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { getIsAlamaly } from 'utils/helpers/getIsAlamaly';

export type SupportedLanguage = 'en' | 'ru' | 'es' | 'fr';

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  'en',
  'ru',
  'es',
  'fr',
];
export const LANGUAGE_STORAGE_KEY = 'sight3_language';

const detectStoredLanguage = (): SupportedLanguage => {
  if (getIsAlamaly()) return 'ru';
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored && SUPPORTED_LANGUAGES.includes(stored as SupportedLanguage)) {
      return stored as SupportedLanguage;
    }
    const browserLang = navigator.language.split('-')[0];
    if (SUPPORTED_LANGUAGES.includes(browserLang as SupportedLanguage)) {
      return browserLang as SupportedLanguage;
    }
  } catch {
    // localStorage unavailable (e.g. SSR or blocked)
  }
  return 'en';
};

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: detectStoredLanguage(),
    fallbackLng: 'en',
    defaultNS: 'translation',
    backend: {
      loadPath: '/locales/{{lng}}.json',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
